import React, { FunctionComponent } from "react";

import { useRelatedCartItems } from "../../../../stores/hooks/useRelatedCartItems";
import { AnyPartItem } from "../../../../stores/slices/cartSlice";
import { Section } from "../../../../ui/Section/Section";
import { TabPanels } from "../../../../ui/TabPanels/TabPanels";
import { useAllowPartPricing } from "../../../../util/useAllowPartPricing";
import { PriceSelectEntry } from "../../../PriceSelect/usePriceSelectState";
import { ContactLeadForm } from "./ContactLeadForm";
import { LeadSuccessView } from "./LeadSuccessView";
import { QuoteForm } from "./QuoteForm";

type DealerTireDetailsProps = {
  isStaggered: boolean;
  part: AnyPartItem | null;
  priceEntries: PriceSelectEntry[];
  setPriceEntries(priceEntries: PriceSelectEntry[]): void;
};

export const Actions: FunctionComponent<DealerTireDetailsProps> = ({
  isStaggered,
  part,
  priceEntries,
  setPriceEntries,
}) => {
  const allowPricing = useAllowPartPricing(
    part,
    priceEntries[0]?.pricingOption ?? null
  );

  const [orderItem] = useRelatedCartItems(part, false);

  return (
    <TabPanels defaultIndex={0}>
      {[
        allowPricing && (
          <Section key="0">
            <QuoteForm
              isStaggered={isStaggered}
              orderItem={orderItem}
              part={part}
              priceEntries={priceEntries}
              setPriceEntries={setPriceEntries}
            />
          </Section>
        ),
        <Section key="1">
          <ContactLeadForm allowPricing={allowPricing} part={part} />
        </Section>,
        <Section key="2">
          <LeadSuccessView allowPricing={allowPricing} />
        </Section>,
      ].filter(Boolean)}
    </TabPanels>
  );
};
